import "./../bindings/bao-toolbar2";
import "./../bindings/bao-date-time-picker";
import "./../bindings/bao-date-time-box";
import "./../bindings/visibility";
import "./../bindings/element";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoMenu from "./../services/bao-menu";
import * as moment from "moment";
import Guid from "./../factories/guid";
import baoRouter from "./../services/bao-router";
import BaoDialog from "./../factories/bao-dialog";
import finitoService from "./../services/finito-service";
import SubscriptionViewModel from "./../factories/subscription-view-model";
import appTabController from "./../services/app-tab-controller";
import WhiteboardHistoryViewModel from "./whiteboard-history";
class WhiteboardViewModel extends SubscriptionViewModel {
    SessionTabId: KnockoutObservable<string>;
    IsHistory: any;
    AutomaticallyReadWhiteboard: any;
    IsNew: any;
    IsWhiteboardMarkedAsReadForUser: any;
    ValidFromHtml: any;
    ValidToHtml: any;
    SaveAllowed: any;
    IsClosed: any;
    WhiteboardPermissions: any;
    boaToolbar2ShowButton: any;
    HasHistory: any;
    TabName: any;
    Instructionrecipient: any;
    WhiteboardRecipientList: any;
    constructor(tabPage) {
        super(tabPage);
        this.Device4Id.subscribe(() => {
            this.SetParentsByDevice4();
        });
        this.Device4NameBinding.subscribe(() => {
            if (!this.TabPage.IsLoading() && this.Device4Id() != null) {
                this.Device4Id(null);
            }
        });
        this.Device3Id.subscribe(() => {
            this.SetParentsByDevice3();
        });
        this.Device3NameBinding.subscribe(() => {
            if (!this.TabPage.IsLoading() && this.Device3Id() != null) {
                this.Device3Id(null);
            }
        });
        this.AreaEquipmentId.subscribe(() => {
            this.SetParentsByAreaEquipment();
        });
        this.AreaEquipmentBinding.subscribe(() => {
            if (!this.TabPage.IsLoading() && this.AreaEquipmentId() != null) {
                this.AreaEquipmentId(null);
            }
        });
        this.AreaId.subscribe(() => {
            this.SetChildrenByArea();
        });
        //
        // WhiteboardType
        this.WhiteboardTypeId.subscribe((whiteboardTypeId) => {
            this.ShowDueDate(!(whiteboardTypeId === finitoService.WhiteboardTypeIds.ValidNoEndDate));
            this.toggleButtons();
        });
        //
        // Textbaustein einfügen
        this.SelectedTextModule.subscribe((selectedTextModule: any) => {
            finitoService.InsertAtCursorPositionContentEditable(this.TextModuleField().querySelector("#userTaggingInput"), selectedTextModule.Text);
        });
        //
        // Dateianhänge
        this.InstructionAttachment["Filtered"] = ko.pureComputed(() => {
            let instructionAttachment = this.InstructionAttachment(), revision = this.Revision();
            if (!isNaN(<any>revision)) {
                return ko.utils.arrayFilter(instructionAttachment, (att: any) => {
                    return att.DeleteInRevision() === null || (att.DeleteInRevision() > this.Revision());
                });
            }
            else {
                return instructionAttachment;
            }
        });
    }
    AppTabController = appTabController;
    TextModuleField = ko.observable();
    ShowDueDate = ko.observable(true);
    WhiteboardTypeId = ko.observable();
    WhiteboardTypes = ko.observableArray();
    Priorities = ko.observableArray();
    Categories = ko.observableArray();
    //this.Instructionrecipient = ko.observableArray().extend({ dirty: this.TabPage.DirtyFlag });
    FormName = ko.observable();
    ReportId = ko.observable();
    InstructionId = ko.observable<string>();
    ShiftbookId = ko.observable();
    Revision = ko.observable();
    //this.SelectedRecipients = ko.observableArray();
    InstructionAttachment = ko.observableArray().extend({ dirty: this.TabPage.DirtyFlag });
    SelectedTextModule = ko.observable();
    showUserTaggingControl: KnockoutObservable<boolean> = ko.observable(true);
    showTextModuleDialog = () => { };
    //this.openRecipientSearcher = () =>{ };
    showAttachmentDialog = () => { };
    uploadAttachment = () => { };
    // wenn nicht vom baseviewmodel abgeleitet wird, muss dieses observable manuell erstellt werden. Muss von anfang an da sein, um die funktion zu gewährleisten
    ShowStatusDialog = ko.observable();
    AreaId = ko.observable<string>().extend({ dirty: this.TabPage.DirtyFlag });
    AreaName = ko.observable<string>().extend({ dirty: this.TabPage.DirtyFlag });
    AreaEquipmentId = ko.observable<string>().extend({ dirty: this.TabPage.DirtyFlag });
    AreaEquipmentBinding = ko.observable<string>().extend({ dirty: this.TabPage.DirtyFlag });
    Device3NameBinding = ko.observable<string>().extend({ dirty: this.TabPage.DirtyFlag });
    Device3Id = ko.observable<string>().extend({ dirty: this.TabPage.DirtyFlag });
    Device4NameBinding = ko.observable<string>().extend({ dirty: this.TabPage.DirtyFlag });
    Device4Id = ko.observable<string>().extend({ dirty: this.TabPage.DirtyFlag });
    IgnoreDeviceChanges = ko.observable(true);
    RawValue = ko.observable("");
    UserTaggingList: KnockoutObservableArray<string> = ko.observableArray([]);
    Focus = () => { };
    ValidToMandatory = ko.pureComputed(() => {
        return this.WhiteboardTypeId() === finitoService.WhiteboardTypeIds.ValidFromTo;
    });
    getTaskAttachments() {
        return Bao.post("Whiteboard/GetAttachments", JSON.stringify({ sessionTabId: this.SessionTabId() }))
            .done((data) => {
                // set
                //this.InstructionAttachment()
            });
    }
    ;
    //
    // Dateianhang hinzufügen
    attachmentAdded = () => {
        this.TabPage.IsLoading(true);
        this.TabPage.DirtyFlag(true);
        this.getTaskAttachments()
            .done((data) => {
                ko.map.fromJS(data, this.InstructionAttachment);
                this.TabPage.IsLoading(false);
            });
    };
    //
    // Dateianhang entfernen
    removeAttachment = (attachment) => {
        if (!this.IsHistory()) {
            this.TabPage.IsLoading(true);
            this.TabPage.DirtyFlag(true);
            // setzte delete flag property
            attachment.DeleteInRevision(this.Revision());
            // set session info
            Bao.post("Whiteboard/RemoveAttachment", JSON.stringify({
                sessionTabId: this.SessionTabId(),
                attachmentId: attachment.InstructionAttachmentId(),
                deleteInRevision: this.Revision()
            })).done(() => {
                this.TabPage.IsLoading(false);
            });
        }
    }
        ;
    init() {
        this.TabPage.IsLoading(true);
        this.ReportId(baoRouter.getRouteValue('reportId', <any>this.TabPage));
        this.InstructionId(baoRouter.getRouteValue('id', <any>this.TabPage));
        if (!this.ShiftbookId()) {
            this.ShiftbookId(baoRouter.getRouteValue('shiftbookid', <any>this.TabPage));
        }
        return $.when(this.get()
            .then(() => {
                if (!this.ShiftbookId()) {
                    this.ShiftbookId(baoRouter.getRouteValue('shiftbookid', <any>this.TabPage));
                }
                return Bao.post("Shiftbook/GetPermissionsForShiftbook", JSON.stringify({ shiftbookId: this.ShiftbookId() }));
            })
            .then((serverResult) => {
                if (!serverResult)
                    return;
                this.WhiteboardPermissions = serverResult.RoleShiftbookPermissions;
                return this.getCategories();
            }), this.getWhiteboardTypes(), this.getPriorities());
    }
    ;
    loaded() {
        if (this.AutomaticallyReadWhiteboard() && !this.IsNew() && !this.IsWhiteboardMarkedAsReadForUser()) {
            this.MarkAsRead(true);
        }
        this.ValidFromHtml.Formatted = ko.pureComputed(() => {
            if (this.ValidFromHtml()) {
                return moment(this.ValidFromHtml(), Bao.Utils.DateTimeFormat).format(Bao.Utils.DateTimeDisplayFormat);
            }
            else {
                return '';
            }
        });
        this.ValidToHtml.Formatted = ko.pureComputed(() => {
            if (this.ValidToHtml()) {
                return moment(this.ValidToHtml(), Bao.Utils.DateTimeFormat).format(Bao.Utils.DateTimeDisplayFormat);
            }
            else {
                return '';
            }
        });
        if (!this.ShiftbookId()) {
            this.ShiftbookId(baoRouter.getRouteValue('shiftbookid', <any>this.TabPage));
        }
        this.registerMenuClick();
        this.toggleButtons();
        this.SetPermissions();
        this.setTabTitle();
        this.refreshUserTagging();
        this.TabPage.IsLoading(false);
        this.Focus();
        this.IgnoreDeviceChanges(false);
        this.TabPage.DirtyFlag.reset();
        return $.Deferred().resolve().promise();
    }
    ;
    BeforeClose(fn) {
        if (this.TabPage.DirtyFlag() && this.SaveAllowed() && !this.IsHistory() && !this.IsClosed()) {
            this.shouldSave().then((shouldSave) => {
                if (shouldSave === true) {
                    this.validate().then((isValid) => {
                        if (isValid) {
                            this.Save().then(() => {
                                fn();
                            });
                        }
                        else {
                            this.showValidationErrors();
                        }
                    });
                }
                else if (shouldSave === false) {
                    fn();
                }
                else {
                    //Save canceled
                }
            });
        }
        else {
            fn();
        }
    }
    ;
    SetPermissions(showBtnsFn?) {
        let permissions = this.WhiteboardPermissions;
        if (!permissions)
            return;
        for (let actionKey in permissions) {
            if (this.boaToolbar2ShowButton) {
                this.boaToolbar2ShowButton(actionKey, permissions[actionKey]);
            }
            if (showBtnsFn) {
                showBtnsFn(actionKey, permissions[actionKey]);
            }
            BaoMenu.permissionVisible({ ActionKey: actionKey, Context: this.TabPage.Context(), Visible: permissions[actionKey] });
        }
    }
    ;
    //
    // ClickHandler für Menü
    registerMenuClick() {
        BaoMenu.registerEvent((btn) => {
            if (this.TabPage != null && this.TabPage.IsActiveTab != null && this.TabPage.IsActiveTab() === true) {
                switch (btn.ActionKey()) {
                    case 'WhiteboardNew':
                        this["new"]();
                        break;
                    case 'WhiteboardSave':
                        if ((this.TabPage.DirtyFlag() || this.IsNew()) && this.SaveAllowed() && !this.IsHistory()) {
                            this.validate().then((isValid) => {
                                if (isValid) {
                                    this.Save();
                                }
                                else {
                                    this.showValidationErrors();
                                }
                            });
                        }
                        break;
                    case 'WhiteboardDelete':
                        this["delete"]();
                        break;
                    case 'WhiteboardHistory':
                        this.history();
                        break;
                    case 'WhiteboardMarkRead':
                        this.MarkAsReadYesNoDialog();
                        break;
                }
            }
        });
    }
    ;
    //
    // Schließen des Tabs möglich?
    canClose() {
        let result = $.Deferred();
        if (this.IsHistory()) {
            result.resolve(true);
        }
        else {
            if (this.TabPage.DirtyFlag() && this.SaveAllowed()) {
                result.resolve(false);
            }
            else {
                result.resolve(true);
            }
        }
        return result.promise();
    }
    ;
    //
    // Wollen Sie die Aufgabe wirklich speichern?
    shouldSave() {
        let deferred = $.Deferred();
        let dialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage(finitoService.MessageKeys.SaveCheck), 'question');
        dialog.DialogResult.subscribe((saveWhiteboard) => {
            deferred.resolve(saveWhiteboard);
        });
        return deferred.promise();
    }
    ;
    //
    // Validieren der Benutzereingaben
    validate() {
        return this.CompleteCheck();
    }
    ;
    CompleteCheck() {
        return Bao.post('Whiteboard/Validate', JSON.stringify({
            reportId: this.ReportId(),
            whiteboardModel: ko.map.toJS(this, true)
        }));
    }
    ;
    //
    // Ein-/Ausblenden der Buttons
    toggleButtons() {
        if (this.IsHistory && this.IsClosed && this.IsNew) {
            let canSave = (!this.IsHistory() && this.SaveAllowed() && !this.IsClosed.peek());
            BaoMenu.permissionEnable({ ActionKey: 'WhiteboardSave', Enabled: canSave, Context: this.TabPage.Context() });
            BaoMenu.permissionEnable({ ActionKey: 'WhiteboardDelete', Enabled: !this.IsHistory() && !this.IsClosed.peek() && !this.IsNew(), Context: this.TabPage.Context() });
            BaoMenu.permissionEnable({ ActionKey: 'WhiteboardHistory', Enabled: this.HasHistory() && !this.IsNew(), Context: this.TabPage.Context() });
            BaoMenu.permissionEnable({ ActionKey: 'WhiteboardMarkRead', Enabled: !this.IsWhiteboardMarkedAsReadForUser() && !this.IsNew(), Context: this.TabPage.Context() });
        }
    }
    ;
    //
    // Titel des Tabs aktualisieren
    setTabTitle() {
        this.TabPage.Title(this.TabName());
    }
    ;
    //
    // Fetch Prioritäten
    getWhiteboardTypes() {
        return Bao.post('Whiteboard/GetWhiteboardTypes', JSON.stringify({
            reportId: this.ReportId(),
        })).then((result) => {
            ko.map.fromJS(result, this.WhiteboardTypes);
        });
    }
    ;
    //
    // Fetch Prioritäten
    getPriorities() {
        return Bao.post('Whiteboard/GetPriorities', JSON.stringify({
            reportId: this.ReportId(),
        })).then((result) => {
            ko.map.fromJS(result, this.Priorities);
        });
    }
    ;
    //
    // Fetch Kategorien
    getCategories() {
        return Bao.post('Whiteboard/GetCategories', JSON.stringify({
            shiftbookId: this.ShiftbookId()
        })).then((result) => {
            ko.map.fromJS(result, this.Categories);
        });
    }
    ;
    //
    // Fetch Aufgabe
    get() {
        return Bao.post('Whiteboard/Get', JSON.stringify({
            reportId: this.ReportId(),
            instructionId: this.InstructionId() || Guid(),
            shiftbookId: this.ShiftbookId()
        })).then((result) => {
            ko.map.fromJS(result, this, this.TabPage.DirtyFlag);

            this.TabPage.DirtyFlag.reset();
        });
    }
    ;
    //
    // Aufgabe erstellen
    'new'() {
        let linkHash = 'whiteboard/' + Guid() + '/' + this.ShiftbookId();
        baoRouter.setHash(linkHash);
    }
    ;
    //
    // Speichern der Aufgabe
    Save() {
        let def = $.Deferred();
        if (this.TabPage.DirtyFlag()) {
            let instructionModel = ko.map.toJS(this, true);
            instructionModel.Instructionrecipient = ko.map.toJS(this.Instructionrecipient);
            instructionModel.InstructionAttachment = ko.map.toJS(this.InstructionAttachment);
            this.TabPage.IsLoading(true);
            Bao.post("whiteboard/Save", JSON.stringify({
                reportId: this.ReportId(),
                whiteboardModel: instructionModel
            })).then((saved) => {
                if (saved) {
                    this.showAlert(finitoService.MessageKeys.SaveSuccessful);
                    this.TabPage.DirtyFlag(false);
                    this.get().then(() => {
                        this.TabPage.IsLoading(false);
                        this.TabPage.ObjectId(this.InstructionId());
                        this.updateHash(this.InstructionId());
                        this.toggleButtons();
                        this.setTabTitle();
                        def.resolve();
                    });
                }
                else {
                    this.showAlert(finitoService.MessageKeys.SaveError, 'info');
                    this.TabPage.IsLoading(false);
                    def.resolve();
                    this.setTabTitle();
                }
                Bao.raiseEvent('user-tagging:save', { entityId: this.InstructionId()});
                Bao.raiseEvent('whiteboardEntries:refresh', { ReportId: this.ReportId() });
            });
        }
        else {
            def.resolve();
        }
        return def.promise();
    }
    ;
    updateHash(instructionId) {
        let currentInstructionId = baoRouter.getRouteValue('id', <any>this.TabPage);
        if (currentInstructionId) {
            let newHash = baoRouter.getHash().replace(currentInstructionId, instructionId);
            if (newHash) {
                baoRouter.setHash(newHash);
            }
        }
    }
    ;
    //
    // Anweisung löschen
    "delete"() {
        let dialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage(finitoService.MessageKeys.WhiteboardDeleteQuestion), 'yesno');
        dialog.DialogResult.subscribe((canDelete) => {
            if (canDelete) {
                this.TabPage.IsLoading(true);
                return Bao.post('whiteboard/Delete', JSON.stringify({
                    reportId: this.ReportId(),
                    instructionIds: [this.InstructionId()]
                })).then((deleted) => {
                    if (deleted > 0) {
                        this.showAlert(finitoService.MessageKeys.WhiteboardDeleteSuccessful);
                        this.TabPage.DirtyFlag(false);
                        Bao.raiseEvent('whiteboardEntries:refresh', { ReportId: this.ReportId() });
                        this.TabPage.IsLoading(false);
                        this.AppTabController.RemoveTab(this.TabPage);
                        this.dispose();
                    }
                    else {
                        this.showAlert(finitoService.MessageKeys.WhiteboardDeleteError, 'info');
                        this.TabPage.IsLoading(false);
                    }
                });
            }
        });
    }
    ;
    //
    // Anweisung löschen
    MarkAsReadYesNoDialog() {
        let dialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage(finitoService.MessageKeys.WhiteboardMarkAsReadQuestion), 'yesno');
        dialog.DialogResult.subscribe((canDelete) => {
            this.MarkAsRead(canDelete);
        });
    }
    ;
    MarkAsRead(canDelete) {
        let deferred = $.Deferred();
        if (canDelete) {
            this.TabPage.IsLoading(true);
            return Bao.post('whiteboard/MarkAsRead', JSON.stringify({
                reportId: this.ReportId(),
                instructionId: this.InstructionId()
            })).then((result) => {
                if (result.Successfull == true) {
                    this.TabPage.DirtyFlag.pause();
                    this.showAlert(finitoService.MessageKeys.WhiteboardMarkAsReadSuccessful);
                    this.IsWhiteboardMarkedAsReadForUser(true);
                    this.WhiteboardRecipientList(result.Recipients);
                    this.TabPage.DirtyFlag.resume();
                }
                else if (result.IsAlreadyMarked == true) {
                    this.showAlert(finitoService.MessageKeys.WhiteboardAlreadyMarked, 'info');
                }
                else {
                    this.showAlert(finitoService.MessageKeys.WhiteboardMarkAsReadError, 'danger');
                }
                this.toggleButtons();
                this.TabPage.IsLoading(false);
            });
        }
        return deferred.promise();
    }
    //
    // Zur nächsten Aufgabe navigieren
    forward() {
        //TODO
    }
    ;
    //
    // Zur vorherigen Aufgabe navigieren
    backward() {
        //TODO
    }
    ;
    //
    // Fetch WhiteboardHistory
    getHistory(historyItem) {
        this.BeforeClose(() => {
            this.TabPage.DirtyFlag(false);
            if (historyItem) {
                if (historyItem.IsNewestRevision()) {
                    this.get().then(() => {
                        this.toggleButtons();
                        this.setTabTitle();
                        if (this.TextModuleField() != undefined) {

                            finitoService.setTextToUserTaggingInput(this.TextModuleField().querySelector("#userTaggingInput"), historyItem.InstructionText(), false)
                        }
                    });
                }
                else {
                    Bao.post('Whiteboard/GetHistory', JSON.stringify({
                        reportId: this.ReportId(),
                        instructionHistoryId: historyItem.InstructionHistoryId()
                    })).then((result) => {
                        ko.map.fromJS(result, this, this.TabPage.DirtyFlag);
                        if (this.TextModuleField() != undefined && result != undefined) {

                            finitoService.setTextToUserTaggingInput(this.TextModuleField().querySelector("#userTaggingInput"), result.InstructionText, result.IsHistory)
                        }
                        this.toggleButtons();
                        this.setTabTitle();
                    });
                }
            }
        });
    }
    ;
    //
    // Historie anzeigen
    history() {
        Bao.get('Whiteboard/History', $.param({
            reportId: this.ReportId()
        })).then((html) => {
            let dialog = new BaoDialog(Bao.Session.GetMessage('msgHistory'));
            dialog.ViewModel(new WhiteboardHistoryViewModel(this.ReportId(), this.InstructionId(), (historyItem) => {
                this.getHistory(historyItem);
                dialog.Close();
            }));
            dialog.Template(html);
            dialog.Buttons([
                {
                    Title: Bao.Session.GetMessage("msgOk"),
                    Click: () => {
                        if (dialog.ViewModel().Selection()) {
                            this.getHistory(dialog.ViewModel().Selection()[0]);
                        }
                        dialog.Close();
                    },
                    Enabled: dialog.ViewModel().HasSelection,
                    IsDefault: ko.observable(),
                    Focus: ko.observable()
                },
                {
                    Title: Bao.Session.GetMessage("msgCancel"),
                    Click: () => {
                        dialog.Close();
                    },
                    Enabled: ko.observable(true),
                    IsDefault: ko.observable(),
                    Focus: ko.observable()
                }
            ]);
            dialog.ViewModel().initialize();
            dialog.Open();
        });
    }
    ;
    SetParentsByDevice4() {
        let def = $.Deferred();
        if (this.IgnoreDeviceChanges() == false) {
            if (this.Device4Id() != null) {
                this.TabPage.IsLoading(true);
                this.IgnoreDeviceChanges(true);
                Bao.post("Device/Device4Parents", JSON.stringify({ device4Id: this.Device4Id() }), (result) => {
                    if (result != null) {
                        if (result.Device3Id != null && this.Device3Id() == null && Bao.Utils.String.IsNullOrWhitespace(this.Device3NameBinding())) {
                            this.Device3Id(result.Device3Id);
                            this.Device3NameBinding(result.Device3Name);
                        }
                        if (result.AreaEquipmentId != null && this.AreaEquipmentId() == null && Bao.Utils.String.IsNullOrWhitespace(this.AreaEquipmentBinding())) {
                            this.AreaEquipmentId(result.AreaEquipmentId);
                            this.AreaEquipmentBinding(result.AreaEquipmentName);
                        }
                        if (result.AreaId != null && this.AreaId() == null && Bao.Utils.String.IsNullOrWhitespace(this.AreaName())) {
                            this.AreaId(result.AreaId);
                            this.AreaName(result.AreaName);
                        }
                    }
                }).always(() => {
                    this.TabPage.IsLoading(false);
                    this.IgnoreDeviceChanges(false);
                    def.resolve();
                });
            }
            else {
                //device 4 deleted
                def.resolve();
            }
        }
        else {
            def.resolve();
        }
        return def.promise();
    }
    ;
    SetParentsByDevice3() {
        let def = $.Deferred();
        if (this.IgnoreDeviceChanges() == false) {
            this.IgnoreDeviceChanges(true);
            if (this.Device3Id() != null) {
                this.TabPage.IsLoading(true);
                $.when(Bao.post("Device/Device3Parents", JSON.stringify({ device3Id: this.Device3Id() }), (result) => {
                    if (result != null) {
                        if (result.AreaEquipmentId != null && this.AreaEquipmentId() == null && Bao.Utils.String.IsNullOrWhitespace(this.AreaEquipmentBinding())) {
                            this.AreaEquipmentId(result.AreaEquipmentId);
                            this.AreaEquipmentBinding(result.AreaEquipmentName);
                        }
                        if (result.AreaId != null && this.AreaId() == null && Bao.Utils.String.IsNullOrWhitespace(this.AreaName())) {
                            this.AreaId(result.AreaId);
                            this.AreaName(result.AreaName);
                        }
                    }
                }), Bao.post("Device/Device3Children", JSON.stringify({ device3Id: this.Device3Id(), device4Id: this.Device4Id() }), (result) => {
                    if (result != null) {
                        if (result.Device4 == false) {
                            this.Device4Id(null);
                            this.Device4NameBinding(null);
                        }
                    }
                })).always(() => {
                    this.TabPage.IsLoading(false);
                    this.IgnoreDeviceChanges(false);
                    def.resolve();
                });
            }
            else {
                //Device3 deleted
                this.Device4Id(null);
                this.Device4NameBinding(null);
                this.IgnoreDeviceChanges(false);
                def.resolve();
            }
        }
        else {
            def.resolve();
        }
        return def.promise();
    }
    ;
    SetParentsByAreaEquipment() {
        let def = $.Deferred();
        if (this.IgnoreDeviceChanges() == false) {
            this.IgnoreDeviceChanges(true);
            if (this.AreaEquipmentId() != null) {
                this.TabPage.IsLoading(true);
                $.when(Bao.post("Device/AreaEqupimentParents", JSON.stringify({ areaEquipmentId: this.AreaEquipmentId() }), (result) => {
                    if (result != null) {
                        if (result.AreaId != null && this.AreaId() == null && Bao.Utils.String.IsNullOrWhitespace(this.AreaName())) {
                            this.AreaId(result.AreaId);
                            this.AreaName(result.AreaName);
                        }
                    }
                }), Bao.post("Device/AreaEquipmentChildren", JSON.stringify({ areaEquipmentId: this.AreaEquipmentId(), device3Id: this.Device3Id(), device4Id: this.Device4Id() }), (result) => {
                    if (result != null) {
                        if (result.Device3 == false) {
                            this.Device3Id(null);
                            this.Device3NameBinding(null);
                        }
                        if (result.Device4 == false) {
                            this.Device4Id(null);
                            this.Device4NameBinding(null);
                        }
                    }
                })).always(() => {
                    this.TabPage.IsLoading(false);
                    this.IgnoreDeviceChanges(false);
                    def.resolve();
                });
            }
            else {
                //AreaEquipment deleted
                this.Device3Id(null);
                this.Device3NameBinding(null);
                this.Device4Id(null);
                this.Device4NameBinding(null);
                this.IgnoreDeviceChanges(false);
                def.resolve();
            }
        }
        else {
            def.resolve();
        }
        return def.promise();
    }
    ;
    SetChildrenByArea() {
        let def = $.Deferred();
        if (this.IgnoreDeviceChanges() == false) {
            this.IgnoreDeviceChanges(true);
            if (this.AreaId() != null) {
                this.TabPage.IsLoading(true);
                Bao.post("Device/AreaChildren", JSON.stringify({ areaId: this.AreaId(), areaEquipmentId: this.AreaEquipmentId(), device3Id: this.Device3Id(), device4Id: this.Device4Id() }), (result) => {
                    if (result != null) {
                        if (result.AreaEquipment == false) {
                            this.AreaEquipmentId(null);
                            this.AreaEquipmentBinding(null);
                        }
                        if (result.Device3 == false) {
                            this.Device3Id(null);
                            this.Device3NameBinding(null);
                        }
                        if (result.Device4 == false) {
                            this.Device4Id(null);
                            this.Device4NameBinding(null);
                        }
                    }
                }).always(() => {
                    this.TabPage.IsLoading(false);
                    this.IgnoreDeviceChanges(false);
                    def.resolve();
                });
            }
            else {
                this.AreaEquipmentBinding(null);
                this.AreaEquipmentId(null);
                this.Device3Id(null);
                this.Device3NameBinding(null);
                this.Device4Id(null);
                this.Device4NameBinding(null);
                this.IgnoreDeviceChanges(false);
                def.resolve();
            }
        }
        return def.promise();
    }
    ;
    private refreshUserTagging() {
        this.showUserTaggingControl(false);
        this.showUserTaggingControl(true);
    }
}
export default WhiteboardViewModel;